export default __webpack_public_path__ + "static/media/ba12.07d56a10.jpg";